import { NgModule } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { LayoutComponent } from './layout.component'
import { SidebarComponent } from '../sidebar/sidebar.component'
import { SidebarTogglerComponent } from '../sidebar-toggler/sidebar-toggler.component'
import { AccordionModule } from '../accordion/accordion.module'
import { LayoutRoutingModule } from './layout-routing.module'
import { ContentComponent } from '../content/content.component'
import { ToastComponent } from 'src/app/service/toast/toast.component'
import { LoadingModule } from 'src/app/service/loading/loading.module'
import { SharedModule } from 'src/app/shared/shared.module'

@NgModule({
  declarations: [LayoutComponent, SidebarComponent, SidebarTogglerComponent, ContentComponent, ToastComponent],
  imports: [CommonModule, AccordionModule, LayoutRoutingModule, LoadingModule, SharedModule],
  providers: [DatePipe],
})
export class LayoutModule {}
